import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-questionnaire-evaluation',
  templateUrl: './questionnaire-evaluation.component.html',
  styleUrls: ['./questionnaire-evaluation.component.css']
})
export class QuestionnaireEvaluationComponent implements OnInit {

  choice: string;
  constructor(public dialogRef: MatDialogRef<QuestionnaireEvaluationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string[]) {
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

}
